import { render, staticRenderFns } from "./generalcolumns.vue?vue&type=template&id=28eee3dc&scoped=true"
import script from "./generalcolumns.vue?vue&type=script&lang=js"
export * from "./generalcolumns.vue?vue&type=script&lang=js"
import style0 from "./generalcolumns.vue?vue&type=style&index=0&id=28eee3dc&prod&scoped=true&lang=scss"
import style1 from "./generalcolumns.vue?vue&type=style&index=1&id=28eee3dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28eee3dc",
  null
  
)

export default component.exports